// Runtime API_ROOT is loaded from config context
// Fallback to build-time value for initial load
export const API_ROOT = process.env.API_ROOT || '';

// Sensitive values remain build-time only
export const { GOOGLE_AUTH_ID } = process.env;
export const { CLOUDFLARE_TURNSTILE_SITE_KEY } = process.env;
export const { GOOGLE_MAP_API_KEY } = process.env;
export const { SENTRY_DSN } = process.env;
export const { SENTRY_ENV } = process.env;
